// Industrial-app route tree.
// Composed from \`sharedRoutes.jsx\` to avoid duplication across modules.

import { Navigate } from 'react-router';

import { AppLayout } from 'app/layouts/AppLayout';
import { DynamicLayout } from 'app/layouts/DynamicLayout';
import TenantSelectorPage from 'app/pages/shared/TenantSelectorPage';
import AdminTenantGuard from 'middleware/AdminTenantGuard';
import AuthGuard from 'middleware/AuthGuard';
import ModuleRoleGuard from 'middleware/ModuleRoleGuard';

import {
  alertDetailsRoute,
  alertsRoutes,
  deviceManagementRoutes,
  devicesLegacyRedirects,
  reportsRoutes,
  settingsRoutes,
} from '../sharedRoutes';

// Industrial-specific dashboard (4-box operational overview).
// Replaces the shared map page used by Monitoring/Manager.
const industrialDashboardRoute = {
  path: 'dashboard',
  lazy: async () => ({
    Component: (await import('app/pages/industrial/dashboard')).default,
  }),
};

const protectedRoutes = {
  id: 'protected',
  Component: AuthGuard,
  children: [
    {
      path: 'select-tenant',
      element: <TenantSelectorPage />,
    },
    {
      Component: AdminTenantGuard,
      children: [
        {
          Component: ModuleRoleGuard,
          children: [
            {
              Component: DynamicLayout,
              children: [
                { index: true, element: <Navigate to="dashboard" replace /> },
                industrialDashboardRoute,
                reportsRoutes,
                alertsRoutes,
                deviceManagementRoutes,
                devicesLegacyRedirects,
                {
                  path: 'data-sharing',
                  children: [
                    {
                      index: true,
                      element: <Navigate to="/data-sharing/export" replace />,
                    },
                    {
                      path: 'export',
                      lazy: async () => ({
                        Component: (
                          await import('app/pages/monitoring/dataSharing/ExportBuilderPage')
                        ).default,
                      }),
                    },
                    {
                      path: 'recent',
                      lazy: async () => ({
                        Component: (
                          await import('app/pages/monitoring/dataSharing/RecentExportsPage')
                        ).default,
                      }),
                    },
                  ],
                },
                alertDetailsRoute,
              ],
            },
            { Component: AppLayout, children: [settingsRoutes] },
          ],
        },
      ],
    },
  ],
};

export { protectedRoutes };
